/**
 * 7elements Revamp – JS enhancements
 */

(function () {
  'use strict';

  /* ── Judge.me: format "4.91 von 5" → "4,9" ── */
  function formatJudgeMeAverage() {
    var avgEl = document.querySelector(
      '.revamp-reviews-section .jdgm-rev-widg__summary-average'
    );
    if (!avgEl) return false;
    var match = avgEl.textContent.trim().match(/[\d.]+/);
    if (!match) return false;
    var num = parseFloat(match[0]);
    if (isNaN(num)) return false;
    avgEl.textContent = num.toFixed(1).replace('.', ',');
    return true;
  }

  function initJudgeMeFormat() {
    if (formatJudgeMeAverage()) return;
    // Widget loads async — watch for DOM additions, disconnect once done
    var observer = new MutationObserver(function (mutations, obs) {
      if (formatJudgeMeAverage()) obs.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJudgeMeFormat);
  } else {
    initJudgeMeFormat();
  }
})();
